<!-- @format -->

<div class="row page-content bane-template">
	<div class="col-12 col-lg-8 col-xl-9 spot">
		<span *ngIf="homrContent['Spot 1'] && homrContent['Spot 1'][0]">
			<a
				*ngIf="homrContent['Spot 1'][0].link && homrContent['Spot 1'][0].link !== 'na'"
				[href]="homrContent['Spot 1'][0].link"
				[attr.data-em]="
					createTag(
						'1',
						homrContent['Spot 1'][0].headline,
						homrContent['Spot 1'][0].Subhead
					)
				"
				class="marketing-content-1">
				<clp-main-marketing-content
					[spotNumber]="'1'"
					[data]="homrContent['Spot 1'][0]">
				</clp-main-marketing-content>
			</a>
			<span
				*ngIf="
					homrContent['Spot 1'][0] !== undefined &&
					homrContent['Spot 1'][0].link &&
					homrContent['Spot 1'][0].link === 'na'
				"
				class="marketing-content-1">
				<clp-main-marketing-content
					[data]="homrContent['Spot 1'][0]"></clp-main-marketing-content>
			</span>
		</span>
	</div>
	<div
		class="col-12 col-lg-4 col-xl-3 content"
		*ngIf="homrContent['Deal Drawer']">
		<div class="title-container">
			<clp-breadcrumb
				*ngIf="
					categoryData &&
					categoryData.breadCrumbDetails &&
					categoryData.breadCrumbDetails.length > 0
				"
				[breadcrumbs]="categoryData.breadCrumbDetails"
				[title]="
					categoryData.note ? categoryData.note : categoryData.name
				"></clp-breadcrumb>
			<h1>{{ categoryData.name }}</h1>
		</div>
		<clp-promotion-banner
			*ngIf="homrContent['Promotional Banner']"
			class="hmf-py-xs hmf-px-m"
			[promotion]="homrContent['Promotional Banner'][0]"></clp-promotion-banner>
		<ng-container *ngIf="isMobile; then mobileAccordian; else largeAccordian"></ng-container>
		<ng-template #mobileAccordian>
			<div class="cats">
				<ng-container
					*ngFor="
						let panel of homrContent['Deal Drawer'];
						index as i;
						trackBy: trackByFn
					">
					<mat-expansion-panel
						*ngIf="!panel.link"
						#mep="matExpansionPanel"
						[expanded]="panel.panelOpenState"
						(opened)="panel.panelOpenState = true"
						(closed)="panel.panelOpenState = false">
						<mat-expansion-panel-header (click)="categoryClick($event, i)">
							<mat-panel-title
								[attr.data-em]="createDealTag(panel.message)"
								[attr.title]="panel.message">
								<span>
									<shared-media-component-media
										*ngIf="panel.image || panel.visualAssets"
										[visualAssets]="panel.visualAssets"
										[image]="panel.image"
										[itemTitle]="panel.message || ''"
										[altText]="''"
										[willLazyLoad]="true">
									</shared-media-component-media>
								</span>
								<strong> {{ panel.message }}</strong>
							</mat-panel-title>
						</mat-expansion-panel-header>
						<ng-template matExpansionPanelContent>
							<div class="row accordian-data">
								<div
									*ngFor="let cat of panel.deals; trackBy: trackByFn"
									class="col-6 col-sm-4 col-md-3 col-lg-3">
									<clp-deal-block
										[data]="cat"
										[drawer]="panel.message"></clp-deal-block>
								</div>
							</div>
							<div class="view-all-container row">
								<div
									class="col"
									(click)="mep.expanded = !mep.expanded">
									<span>Close</span>
									<homefield-icon name="chevron-up"></homefield-icon>
								</div>
							</div>
						</ng-template>
					</mat-expansion-panel>
					<a
						[href]="panel.link"
						class="category-link"
						*ngIf="panel.link"
						[attr.data-em]="createDealTag(panel.message)"
						[attr.title]="panel.message">
						<span>
							<shared-media-component-media
								*ngIf="panel.image || panel.visualAssets"
								[visualAssets]="panel.visualAssets"
								[image]="panel.image"
								[itemTitle]="panel.message || ''"
								[altText]="''"
								[willLazyLoad]="true">
							</shared-media-component-media>
						</span>
						<strong *ngIf="panel.message !== null"> {{ panel.message }}</strong>
					</a>
				</ng-container>
			</div>
		</ng-template>
		<ng-template #largeAccordian>
			<div
				class="cats"
				[ngClass]="{ 'overflow-category': homrContent['Deal Drawer'].length > 9 }"
				(scroll)="hideCategory($event)">
				<ng-container
					*ngFor="
						let panel of homrContent['Deal Drawer'];
						index as i;
						trackBy: trackByFn
					">
					<mat-expansion-panel
						*ngIf="!panel.link"
						#mep="matExpansionPanel"
						[expanded]="panel.panelOpenState"
						(opened)="panel.panelOpenState = true"
						(closed)="panel.panelOpenState = false"
						(mouseenter)="panel.panelOpenState = true"
						(mouseleave)="panel.panelOpenState = false; hideAllSubCategories()">
						<mat-expansion-panel-header
							(click)="categoryClick($event, i)"
							(mouseenter)="categoryClick($event, i)">
							<mat-panel-title
								[attr.data-em]="createDealTag(panel.message)"
								[attr.title]="panel.message">
								<span>
									<shared-media-component-media
										*ngIf="panel.image || panel.visualAssets"
										[visualAssets]="panel.visualAssets"
										[image]="panel.image"
										[itemTitle]="panel.message || ''"
										[altText]="''"
										[willLazyLoad]="true">
									</shared-media-component-media>
								</span>
								<strong> {{ panel.message }}</strong>
							</mat-panel-title>
						</mat-expansion-panel-header>
						<ng-template matExpansionPanelContent>
							<div class="row accordian-data">
								<div
									*ngFor="let cat of panel.deals; trackBy: trackByFn"
									class="col-4 col-xl-3">
									<clp-deal-block
										[data]="cat"
										[drawer]="panel.message"></clp-deal-block>
								</div>
							</div>
							<div class="view-all-container row">
								<div
									class="col"
									(click)="mep.expanded = !mep.expanded">
									<span>Close</span>
									<homefield-icon name="chevron-up"></homefield-icon>
								</div>
							</div>
						</ng-template>
					</mat-expansion-panel>
					<a
						[href]="panel.link"
						class="category-link"
						*ngIf="panel.link"
						[attr.data-em]="createDealTag(panel.message)"
						[attr.title]="panel.message">
						<span>
							<shared-media-component-media
								*ngIf="panel.image || panel.visualAssets"
								[visualAssets]="panel.visualAssets"
								[image]="panel.image"
								[itemTitle]="panel.message || ''"
								[altText]="''"
								[willLazyLoad]="true">
							</shared-media-component-media>
						</span>
						<strong *ngIf="panel.message !== null"> {{ panel.message }}</strong>
					</a>
				</ng-container>
			</div>
		</ng-template>
	</div>
</div>
